import type { RouteLocationNormalized } from "vue-router";
import { auth } from "@/core/store/auth";
import { user } from "@/core/store/UserState";
import { unmatched } from "./routes";
import { useAppContextStore } from "@/core/store";
import { useAuthToken } from "@/core/composables/useAuthToken";

export const initializeContext = () => {
  const appContext = useAppContextStore();
  appContext.resetAll(); // sets defaultUserContext
};

export const isGuardedRoute = (to: RouteLocationNormalized) =>
  to.meta?.requiresAuth !== false && !to.matched.some((r) => r.path === unmatched);

const clearAuthState = async () => {
  const { clearToken } = useAuthToken();
  clearToken();

  // handle boolean or Ref<boolean>
  if (
    user.authenticated &&
    typeof user.authenticated === "object" &&
    "value" in (user.authenticated as any)
  ) {
    (user.authenticated as any).value = false;
  }

  if (auth.initialized && auth.logout) {
    try {
      await auth.logout();
    } catch {
      // swallow logout errors
    }
  }
};

type AuthInitClient = Parameters<typeof auth.initialize>[0];

export const ensureAuth = async (to: RouteLocationNormalized, client: AuthInitClient) => {
  if (!isGuardedRoute(to)) return true;

  if (!auth.initialized) {
    await auth.initialize(client);
  }

  if (auth.account) {
    const { token } = useAuthToken();
    const isAuthed =
      typeof user.authenticated === "boolean"
        ? user.authenticated
        : Boolean((user.authenticated as any)?.value);

    if (!token.value || !isAuthed) {
      await user.load();
    }
    return true;
  }

  try {
    await auth.login();
    return false;
  } catch {
    await clearAuthState();
    return false;
  }
};
